import { createFileRoute } from '@tanstack/react-router';

import { BankSettingsPage } from '../../../features/finance/ui/bank-settings-page.tsx';
import { requireSettingsPermission } from '../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/settings/bank')({
  // Подключение Т-Банка — только `finance.manage`: токен, счета, синхронизация.
  beforeLoad: requireSettingsPermission('finance.manage'),
  component: BankSettingsPage,
});
